import { Messages } from '../../codegen/Localize';
import { Formatters} from '../../codegen/Localize';
import {
  ActionHelpers,   standardActionErrorMsg,
standardActionSuccessMsg
} from '../../commonInfra/contentActions/ActionHelpers';
import {
  IErrorDetail
} from '../../commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '../../commonInfra/contentActions/MultipleItemResult';
import { openReactConfirmationDialog } from '../../commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '../../commonInfra/dialogs/style/TabDialogWidth';
import { ExtractTasks } from '../../extract/resources/ExtractTasks';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { DatasourceContentType, WorkbookContentType } from '../../spacesPlatform/models/ContentTypes';
import { SchedulingErrorCode } from '../../ts/helpers/ErrorCodes';
import { L10n } from '../../ts/L10n/L10n';
import { IExtractTaskInfo } from '../../ts/models/IExtractTaskInfo';
import { INamedItemInfo } from '../../ts/models/resourceInfoParts';
import { Set } from '../../ts/models/Set';
import { ContentUrlForItem } from '../../ts/services/ContentUrl';

function executeWithContext(extractTasks: Set<IExtractTaskInfo>): Promise<IResult> {
    let description: string;
    if(extractTasks.size() === 1) {
        const task = extractTasks.first();
        if (task.workbook) {
            description = Messages.confirmDeleteExtractWorkbook({ PARENT_NAME: L10n.elideIfLong(task.workbook.name) });
        } else if (task.datasource) {
            description = Messages.confirmDeleteExtractDatasources({ PARENT_NAME: L10n.elideIfLong(task.datasource.name) });
        } else if (task.virtualConnection) {
            description = Messages.confirmDeleteExtractVirtualConnection({ PARENT_NAME: L10n.elideIfLong(task.virtualConnection.name) });
        }
    }
    else {
        description = Messages.confirmDeleteExtracts({ITEM_COUNT_LOC: Formatters.formatCount(extractTasks.size())});
    }

    const dialogInstance = openReactConfirmationDialog<string[], IResult> ({
        title: Messages.deleteMessage(),
        message: description,
        actionName: Messages.confirmDeleteButton({ITEM_COUNT: extractTasks.size(),ITEM_COUNT_LOC: Formatters.formatCount(extractTasks.size())}),
        action: () => ExtractTasks.del(extractTasks.keys()),
        isActionDelete: true,
        paramsForAction: extractTasks.keys(),
        dialogWidth: TabDialogWidth.width375px
    });

    dialogInstance.result.then((result: IResult) => {
        notifyResult(extractTasks, result);
    });

    return Promise.resolve(dialogInstance.result);
}

function notifyResult(extractTasks: Set<IExtractTaskInfo>, result: IResult) {
    ActionHelpers.displayStandardToastsForResult(
        extractTasks,
        result,
        {
            success: standardActionSuccessMsg(Messages.deleteExtractTasksSuccess),
            error: standardActionErrorMsg(Messages.deleteExtractTasksError),
        },
        (errorItem: IErrorItem<IExtractTaskInfo>) => errorDetailsFor(errorItem)
    );
}

function errorDetailsFor(errorItem: IErrorItem<IExtractTaskInfo>): IErrorDetail {
    const namedItem: INamedItemInfo = errorItem.item.workbook || errorItem.item.datasource;
    return {
    itemName: namedItem.name,
    itemUrl: urlFor(errorItem),
    errorMessage: errorMessageFor(errorItem)
    };
}

function urlFor(errorItem: IErrorItem<IExtractTaskInfo>): string {
    let href: string;
    if(errorItem.item.workbook) {
        href = ContentUrlForItem(errorItem.item.workbook, WorkbookContentType);
    }
    if(errorItem.item.datasource) {
        href = ContentUrlForItem(errorItem.item.datasource, DatasourceContentType);
    }
    return href;
}

function errorMessageFor(errorItem: IErrorItem<IExtractTaskInfo>) {
    switch (errorItem.error.code) {
        case SchedulingErrorCode.SchedulingTaskNotFound:
            if(errorItem.item.workbook)
                return Messages.errorExtractTaskForWorkbookNotFound({
                    WORKBOOK_NAME: L10n.elideIfLong(errorItem.item.workbook.name),
                    SCHEDULE_NAME: L10n.elideIfLong(errorItem.item.schedule.name)
                });
            if(errorItem.item.datasource)
                return Messages.errorExtractTaskForDatasourceNotFound ({
                    DATASOURCE_NAME: L10n.elideIfLong(errorItem.item.datasource.name),
                    SCHEDULE_NAME: L10n.elideIfLong(errorItem.item.schedule.name)
                });
        }
    }

export const DeleteExtractTasksAction = {
    executeWithContext
  };

export type DeleteExtractTasksAction = typeof DeleteExtractTasksAction;
